import React from 'react';

const ProfileEdit = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.25"
        y="1.25"
        width="21.5"
        height="21.5"
        rx="10.75"
        fill="#CCCCCC"
      />
      <rect
        x="1.25"
        y="1.25"
        width="21.5"
        height="21.5"
        rx="10.75"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5442 7.44149C13.9751 6.92649 14.7497 6.85097 15.2754 7.27312C15.3045 7.29603 16.2383 8.02149 16.2383 8.02149C16.8158 8.3706 16.9953 9.11278 16.6383 9.67915C16.6193 9.70949 11.3397 16.3135 11.3397 16.3135C11.164 16.5327 10.8974 16.662 10.6125 16.6651L8.59058 16.6905L8.13502 14.7623C8.07121 14.4912 8.13502 14.2065 8.31067 13.9874L13.5442 7.44149Z"
        stroke="white"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5669 8.66711L15.5959 10.9933"
        stroke="white"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ProfileEdit;